// extracted by mini-css-extract-plugin
export default {"controlGrid":"AddOrEditBanner_controlGrid__knwkc","instructions":"AddOrEditBanner_instructions__CptwS","icon":"AddOrEditBanner_icon__lvzPP"};